import React from 'react'
import Layout from './Layout'
import Header from './Header'
import Features from './Features'
import Video from './Video'
import Analytics from './Analytics'
import Pricing from './Pricing'
import Testimonials from './Testimonials'
import Faq from './Faq'
import CallToAction from './CallToAction'

function App() {
  return (
    <Layout>
      <Header />
      <Features />
      <Video />
      <Analytics />
      <Pricing />
      <Testimonials />
      <Faq />
      <CallToAction />
    </Layout>
  )
}

export default App
